import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  LogoSelection,
  TenantConfigurationForm,
} from '../../configuracoes.models';
import { SettingsCardComponent } from '../../components/settings-card/settings-card.component';
import { compressImageIfNeeded } from '@shared/utils/compress-image.util';

const ACCEPTED_LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
const MAX_LOGO_SIZE = 2 * 1024 * 1024;

@Component({
  selector: 'app-tenant-identity-tab',
  standalone: true,
  imports: [
    ReactiveFormsModule, 
    SettingsCardComponent,
  ],
  templateUrl: './tenant-identity-tab.component.html',
  styleUrl: './tenant-identity-tab.component.scss',
})
export class TenantIdentityTabComponent implements OnDestroy {
  @Input({ required: true }) form!: TenantConfigurationForm;
  @Input() logoPreview: string | null = null;
  @Input() disabled = false;

  @Output() readonly logoChange = new EventEmitter<LogoSelection>();
  @Output() readonly validationError = new EventEmitter<string>();

  private previewObjectUrl: string | null = null;

  async onLogoChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';

    if (!file) return;

    if (!ACCEPTED_LOGO_TYPES.includes(file.type)) {
      this.validationError.emit('Use uma imagem PNG, JPG ou WEBP.');
      return;
    }

    if (file.size > MAX_LOGO_SIZE) {
      this.validationError.emit('O logotipo não pode exceder 2 MB.');
      return;
    }

    const compressedFile = await compressImageIfNeeded(file);
    this.revokePreviewObjectUrl();
    this.previewObjectUrl = URL.createObjectURL(compressedFile);
    this.logoChange.emit({ file: compressedFile, previewUrl: this.previewObjectUrl });
  }

  removeLogo(): void {
    this.revokePreviewObjectUrl();
    this.logoChange.emit({ file: null, previewUrl: null });
  }

  ngOnDestroy(): void {
    this.revokePreviewObjectUrl();
  }

  private revokePreviewObjectUrl(): void {
    if (!this.previewObjectUrl) return;
    URL.revokeObjectURL(this.previewObjectUrl);
    this.previewObjectUrl = null;
  }

  tenantInitials(): string {
    return (this.form.controls.nome.value || 'Tenant')
      .slice(0, 2)
      .toUpperCase();
  }
}
